(function () {
  'use strict';

  function initSlider(wrap) {
    var track = wrap.querySelector('.lp-mechanism__grid');
    var prevBtn = wrap.querySelector('[data-lp-mechanism-prev]');
    var nextBtn = wrap.querySelector('[data-lp-mechanism-next]');
    var dotsContainer = wrap.parentElement.querySelector('[data-lp-mechanism-dots]');
    if (!track) return;
    var cards = Array.from(track.querySelectorAll('.lp-mechanism__card'));
    if (cards.length < 2) return;
    var dots = dotsContainer ? Array.from(dotsContainer.querySelectorAll('.lp-mechanism__dot')) : [];

    function setActiveDot(idx) {
      dots.forEach(function (d, i) {
        d.classList.toggle('lp-mechanism__dot--active', i === idx);
      });
    }

    function centerOffset(el) {
      return el.offsetLeft - (track.clientWidth - el.offsetWidth) / 2;
    }

    function scrollToCard(idx, behavior) {
      var target = cards[idx];
      if (!target) return;
      track.scrollTo({ left: Math.max(0, centerOffset(target)), behavior: behavior || 'smooth' });
    }

    function getCenteredIndex() {
      var trackCenter = track.scrollLeft + track.clientWidth / 2;
      var closest = 0;
      var minDist = Infinity;
      cards.forEach(function (card, i) {
        var cardCenter = card.offsetLeft + card.offsetWidth / 2;
        var dist = Math.abs(cardCenter - trackCenter);
        if (dist < minDist) { minDist = dist; closest = i; }
      });
      return closest;
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { scrollToCard(i, 'smooth'); });
    });

    prevBtn && prevBtn.addEventListener('click', function () {
      scrollToCard(Math.max(0, getCenteredIndex() - 1), 'smooth');
    });
    nextBtn && nextBtn.addEventListener('click', function () {
      scrollToCard(Math.min(cards.length - 1, getCenteredIndex() + 1), 'smooth');
    });

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        setActiveDot(getCenteredIndex());
      }, 90);
    });
  }

  function init() {
    document.querySelectorAll('[data-lp-mechanism-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
